import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';

const useFetchExportMetadata = (token?: string) => {
  return useQuery({
    queryKey: ['fetch-export-metadata', token],
    queryFn: async () => {
      if (!token) throw new Error('No token provided');
      return (await publicExportsApi.publicExportsControllerFindMetadata(token)).data;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportMetadata;
